// extracted by mini-css-extract-plugin
export var desktopTitle = "UpgradeThanks_desktopTitle__FKysx";
export var image = "UpgradeThanks_image__zeHBX";
export var imageContainer = "UpgradeThanks_imageContainer__Ex4QG";
export var messageContainer = "UpgradeThanks_messageContainer__DuL+1";
export var mobileTitle = "UpgradeThanks_mobileTitle__NQGHu";
export var submitButton = "UpgradeThanks_submitButton__u8fF0";
export var upgradeThanks = "UpgradeThanks_upgradeThanks__1zXHG";